/**
 * Takes a point in inches and converts the z-up to the y-up and
 * gives back a point in meters
 * @param {Array} point - 3D coordinate in inches
 * @returns {Array} - coordinates in meters
 * @example
 * const newCoords = convertZUpToYUp([1, 10, 100]);
 * // newCoords === [0.0254, 2.54, -0.254]
 */
export const convertZUpToYUp = (point) => {
  const result = [...point];
  result[0] *= 0.0254;
  result[1] *= 0.0254;
  result[2] *= 0.0254;

  const tmp = result[1];
  result[1] = result[2];
  result[2] = -tmp;

  return result;
};

/**
 * Takes a 3d coordinate and returns a 3d vector
 * @param {Array} position - 3d coordinate
 * @returns {THREE.Vector3} a three.js vector
 * @see https://threejs.org/docs/#api/en/math/Vector3
 */
export const convertPointTo3DVector = (position) =>
  new Hover.Vector3().fromArray(convertZUpToYUp(position));

/**
 * Takes start and end coords and returns a 3d line
 * @param {Object} coords
 * @param {Array} coords.start - 3d coordinate
 * @param {Array} coords.end - 3d coordinate
 * @returns {THREE.Line3} a three.js line
 * @see https://threejs.org/docs/#api/en/math/Line3
 */
export const convertSegmentTo3DLine = ({ start, end }) =>
  new Hover.Line3(
    convertPointTo3DVector(start.position),
    convertPointTo3DVector(end.position),
  );

export default {
  convertZUpToYUp,
  convertPointTo3DVector,
  convertSegmentTo3DLine,
};
